import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { ChartTooltip, getChartValueShare } from '../../../Chart'
import { ProgressBar } from '../../../ProgressBar'
import Text from '../../../Text'
import { formatBirdviewKpiValue } from '../../DashboardBirdview.utils.charts'

import {
  checkIsBirdviewBarsChartRowStacked,
  getBirdviewBarsChartRowSegments,
  getBirdviewBarsChartRowTooltipRows,
  getBirdviewBarsChartSegmentStyle,
} from './BirdviewBarsChartRow.utils'

import * as styles from './BirdviewBarsChartRow.module.css'

function BirdviewBarsChartRow({
  isActive,
  isStacked,
  isTooltipBelow,
  item,
  maxValue,
  total,
  valueUnit,
  withShare,
  onEnter,
  onOpen,
}) {
  const { t } = useTranslation()

  function handleMouseEnter() {
    onEnter(item.id)
  }

  return (
    <li
      className={classNames(styles.row, {
        [styles.interactive]: item.isOpenable,
        [styles.muted]: item.isMuted,
      })}
      onClick={item.isOpenable ? onOpen : undefined}
      onMouseEnter={handleMouseEnter}
    >
      {isActive ? (
        <ChartTooltip
          className={classNames(styles.tooltip, {
            [styles.below]: isTooltipBelow,
          })}
          rows={getBirdviewBarsChartRowTooltipRows({
            isStacked,
            item,
            t,
            total,
            valueUnit,
            withShare,
          })}
          title={item.label}
        />
      ) : null}
      <Text isSecondary className={styles.label}>
        {item.label}
      </Text>
      <span className={styles.track}>
        {checkIsBirdviewBarsChartRowStacked({ isStacked, item }) ? (
          getBirdviewBarsChartRowSegments(item).map(segment => (
            <span
              className={styles.segment}
              key={segment.key}
              style={getBirdviewBarsChartSegmentStyle({
                color: segment.color,
                maxValue,
                value: item[segment.key],
              })}
            />
          ))
        ) : (
          <ProgressBar
            className={styles.bar}
            progress={getChartValueShare(item.value, maxValue)}
          />
        )}
      </span>
      <Text className={styles.value}>
        {formatBirdviewKpiValue({ t, unit: valueUnit, value: item.value })}
      </Text>
    </li>
  )
}

export default BirdviewBarsChartRow
